import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

function IdpProcessingCard({ progressPercent, errorMessage, correlationId }) {
  const { t } = useTranslation();
  const bounded = Math.max(0, Math.min(100, Math.round(progressPercent)));

  return (
    <div className="idp-card idp-processing-card">
      <p className="idp-processing-card__title">{t('idpPage.processing.title')}</p>
      <p className="idp-processing-card__subtitle">{t('idpPage.processing.subtitle')}</p>
      <div className="idp-progress" aria-hidden={!!errorMessage}>
        <div
          className="idp-progress__bar"
          style={{ width: `${bounded}%` }}
        />
      </div>
      <p className="idp-progress__text">{bounded}%</p>
      {errorMessage ? (
        <div className="idp-error-text idp-processing-card__error" role="alert">
          <p className="idp-error-text__message">{errorMessage}</p>
          {correlationId ? (
            <p className="idp-error-text__correlation">
              {t('idpPage.errors.correlationId', { id: correlationId })}
            </p>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}

IdpProcessingCard.propTypes = {
  progressPercent: PropTypes.number.isRequired,
  errorMessage: PropTypes.string,
  correlationId: PropTypes.string,
};

IdpProcessingCard.defaultProps = {
  errorMessage: null,
  correlationId: null,
};

export default IdpProcessingCard;
